// 波兰语
export const GUIDES = [
  { name: 'guide-overview', title: 'Przegląd funkcji', groupIndex: 0 },
  { name: 'guide-account', title: 'Informacje o koncie', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Informacje o pojeździe', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Jak skonfigurować tablicę rozdzielczą', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Jak ustawić pojazd', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Jak nawigować, aby znaleźć pojazd', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Jak korzystać z nawigacji', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Informacje o historii jazdy', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Jak przeprowadzić samokontrolę pojazdu', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Jak wprowadzić ogólne ustawienia aplikacji', groupIndex: 3 },
  { name: 'guide-notice', title: 'Jak wyświetlić i ustawić powiadomienie o wiadomości', groupIndex: 3 },
  { name: 'guide-about', title: 'O aplikacji', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'Aż do',
  1: 'Brak odpowiedzi',
  2: 'Odpowiedź',
  3: 'w komunikacji',
  4: 'środki zaradcze',
  5: 'rozwiązany',
};

export const FEEDBACK_TYPES = {
  1: 'Informacje zwrotne',
  2: 'Odpowiedz',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
